import { createSlice } from '@reduxjs/toolkit'

export const REDIRECT_TO_ERROR_PAGE = [
    'E_SECURITY_EXCEPTION',
    'E_API_KEY_NOT_FOUND',
    'E_API_KEY_DISABLED',
    'API_PAYMENT_BACK_URL_MISSING',
    'API_CART_REMOVE_TICKET_DATA_TOO_BIG',
    'E_API_CART_CURRENCY_NOT_DEFINED',
    'E_API_CART_CINEMA_NOT_DEFINED',
    'E_API_EVENT_NOT_SHARED',
    'API_PERMISSION_DENIED',
    'API_INTERNAL_ERROR',
    'API_FORBIDDEN_OPERATION',
    'API_NOT_IMPLEMENTED',
    'API_NOT_SUPPORTED',
    'API_DATABASE_OVERLOAD',
    'API_UNAUTHORIZED_STATION',
]

// example of state: [{ code: 'TOKEN_FAILED', type: "ERROR"}, ...]

const windowMessageSlice = createSlice({
    name: 'WindowMessage',
    initialState: {
        messages: [],
    },
    reducers: {
        setErrorMessage(state, action) {
            const { payload } = action
            if (REDIRECT_TO_ERROR_PAGE.includes(payload)) {
                return
            }

            const alreadyDisplayed = state.messages.some((message) => message.code === payload)
            if (alreadyDisplayed) {
                return
            }
            state.messages.push({ code: payload, type: 'ERROR' })
        },
        setSuccessMessage(state, action) {
            const { payload } = action
            const alreadyDisplayed = state.messages.some((message) => message.code === payload)
            if (alreadyDisplayed) {
                return
            }

            state.messages.push({ code: payload, type: 'SUCCESS' })
        },
        setPurpleNotification(state, action) {
            const { payload } = action
            const alreadyDisplayed = state.messages.some((message) => message.code === payload)
            if (alreadyDisplayed) {
                return
            }

            state.messages.push({ code: payload, type: 'NOTIFICATION_PURPLE' })
        },
        removeMessage(state, action) {
            const payload = action.payload
            const newMessages = state.messages.filter((message) => JSON.stringify(message) !== JSON.stringify(payload))
            state.messages = newMessages
        },
        removeAllMessages(state) {
            state.messages = []
        },
    },
})

const { actions, reducer } = windowMessageSlice

export const { setErrorMessage, setSuccessMessage, setPurpleNotification, removeMessage, removeAllMessages } = actions

export default reducer
